<div class="address-form" ref="formElement" @focusin="markFormInteraction" @pointerdown="markFormInteraction">
  <NBRadioGroup :options="addressTypes" valueKey="type" v-if="allowStation && isGermany" v-model="localAddress.station_deliver">
    <template #default="{ option }">
      <div class="label">{{ option.label }}</div>
    </template>
  </NBRadioGroup>
  <div class="error" v-if="errors.generic">{{ errors.generic }}</div>
  <div class="fields-holder">
    <NBFormSelect
      v-model="genderValue"
      :error="errors.gender"
      :options="genderOptions"
      @clear-error="emit('clearField', 'gender')"
      :label="$t('app.address.fields.gender', { isMandatory: requiredFields.includes('gender') ? '*' : '' })"
    />
    <NBFormInput
      :error="errors.email"
      v-model="localAddress.email"
      autocomplete="email"
      name="email"
      @clear-error="emit('clearField', 'email')"
      :label="$t('app.address.fields.email', { isMandatory: requiredFields.includes('email') ? '*' : '' })"
      :isHidden="isLoggedIn"
    />
    <NBFormInput
      :error="errors.firstname"
      v-model="localAddress.firstname"
      autocomplete="given-name"
      name="firstname"
      @clear-error="emit('clearField', 'firstname')"
      :label="$t('app.address.fields.firstname', { isMandatory: requiredFields.includes('firstname') ? '*' : '' })"
    />
    <NBFormInput
      :error="errors.lastname"
      v-model="localAddress.lastname"
      autocomplete="family-name"
      name="lastname"
      @clear-error="emit('clearField', 'lastname')"
      :label="$t('app.address.fields.lastname', { isMandatory: requiredFields.includes('lastname') ? '*' : '' })"
    />
    <NBFormInput
      v-model="localAddress.company"
      autocomplete="organization"
      name="company"
      :label="$t('app.address.fields.company', { isMandatory: requiredFields.includes('company') ? '*' : '' })"
    />
    <NBFormInput
      v-model="localAddress.address_details"
      autocomplete="section-company department"
      name="department"
      :label="$t('app.address.fields.address_details', { isMandatory: requiredFields.includes('address_details') ? '*' : '' })"
    />
    <template v-if="localAddress.station_deliver === 'address'">
      <NBFormInput
        :error="errors.address"
        v-model="localAddress.address"
        autocomplete="shipping street-address"
        name="street"
        @clear-error="emit('clearField', 'address')"
        :label="$t('app.address.fields.address', { isMandatory: requiredFields.includes('address') ? '*' : '' })"
      />
      <NBFormInput
        :error="errors.house_number"
        v-model="localAddress.house_number"
        autocomplete="shipping house-number"
        name="housenumber"
        @clear-error="emit('clearField', 'house_number')"
        :label="$t('app.address.fields.house_number', { isMandatory: requiredFields.includes('house_number') ? '*' : '' })"
      />
    </template>
    <template v-else>
      <NBFormInput
        :error="errors.packstation"
        v-model="localAddress.packstation"
        autocomplete="off"
        name="packstation"
        @clear-error="emit('clearField', 'packstation')"
        :label="$t('my_account.register.pack_number')"
      />
      <NBFormInput
        :error="errors.postnumber"
        v-model="localAddress.postnumber"
        autocomplete="off"
        name="postnumber"
        @clear-error="emit('clearField', 'postnumber')"
        :label="$t('my_account.register.post_number')"
      />
    </template>
    <NBFormInput
      :error="errors.zip"
      v-model="localAddress.zip"
      autocomplete="shipping postal-code"
      name="zip"
      @clear-error="emit('clearField', 'zip')"
      :label="$t('app.address.fields.zip', { isMandatory: requiredFields.includes('zip') ? '*' : '' })"
    />
    <NBFormInput
      :error="errors.city"
      v-model="localAddress.city"
      autocomplete="shipping address-level2"
      name="city"
      @clear-error="emit('clearField', 'city')"
      :label="$t('app.address.fields.city', { isMandatory: requiredFields.includes('city') ? '*' : '' })"
    />
    <NBPhoneInput
      :error="errors.phone"
      :countries="countryPhoneCodes"
      v-model:phone="localAddress.phone"
      @clear-error="emit('clearField', 'phone')"
      v-model:phone_country_code="localAddress.phone_country_code"
      :label="$t('app.address.fields.phone', { isMandatory: requiredFields.includes('phone') ? '*' : '' })"
    />
    <NBFormSelect
      class="country"
      :options="countries"
      v-model="countryValue"
      :error="errors.country"
      @clear-error="emit('clearField', 'country')"
      v-if="localAddress.station_deliver === 'address'"
      :label="$t('app.address.fields.country', { isMandatory: requiredFields.includes('country') ? '*' : '' })"
    />
    <NBToggle :label="$t('app.address.set_default')" v-model="localAddress.is_default" v-if="isLoggedIn && !hideDefault" />
  </div>
  <div class="info">{{ $t('my_account.register.required_fields') }}</div>
  <button type="submit" class="b b-A btn-save" v-if="showSave" @click.prevent="handleSubmit" :disabled="!canSubmit">{{ $t('my_account.save') }}</button>
</div>
